import * as yup from 'yup';

import { pl } from './yup-locale.js';

yup.setLocale(pl);

const NAME_PART_REGEX = /^[\p{L}' -]+$/gui;
const TAX_ID_REGEX = /^([A-Z]{2})?(([0-9]{10})|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/;
const ZIP_CODE_REGEX = /^\d{2}-\d{3}$/;
const PHONE_NUMBER_REGEX = /^[0-9()\-.+ ]+$/;
const ADDRESS_PART_REGEX = /^[\p{L}0-9'\/\-()., ]+$/gui;
const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

const standardString = label => yup.string().max(255).label(label);

export let billingAddress = yup.object().shape({
  b2b: yup
    .boolean()
    .required(),
  first_name: standardString('Imię')
    .when("b2b", {
      is: false,
      then: () =>yup.string().required().matches(NAME_PART_REGEX)
    }),
  last_name: standardString('Nazwisko')
    .when("b2b", {
      is: false,
      then: () => yup.string().required().matches(NAME_PART_REGEX)
    }),
  company_name: standardString('Nazwa firmy')
    .when("b2b", {
      is: true,
      then: () => yup.string().required()
    }),
  tax_id:   standardString('NIP')
    .when("b2b", {
      is: true,
      then: () => yup.string().required().matches(TAX_ID_REGEX)
    }),
  street:    standardString('Ulica').required().matches(ADDRESS_PART_REGEX),
  building:  standardString('Budynek').required().matches(ADDRESS_PART_REGEX),
  apartment: standardString('Lokal').nullable().matches(ADDRESS_PART_REGEX, { excludeEmptyString: true }),
  city:      standardString('Miejscowość').required().matches(ADDRESS_PART_REGEX),
  zipcode:   yup
    .string()
    .required()
    .matches(ZIP_CODE_REGEX, "Format 00-000")
    .label("Kod pocztowy"),
  country:   standardString('Kraj').required().matches(NAME_PART_REGEX)
});

export let deliveryAddress = yup.object().shape({
  first_name: standardString('Imię').required(),
  last_name:  standardString('Nazwisko').required(),
  street:    standardString('Ulica').required().matches(ADDRESS_PART_REGEX),
  building:  standardString('Budynek').required().matches(ADDRESS_PART_REGEX),
  apartment: standardString('Lokal').nullable().matches(ADDRESS_PART_REGEX, { excludeEmptyString: true }),
  city:      standardString('Miejscowość').required().matches(ADDRESS_PART_REGEX),
  zipcode:    yup
    .string()
    .required()
    .matches(ZIP_CODE_REGEX, "Format 00-000")
    .label("Kod pocztowy"),
  country:   standardString('Kraj').required().matches(NAME_PART_REGEX)
});

export let basicData = yup.object().shape({
  email: standardString('E-mail').required().matches(EMAIL_REGEX, 'Nieprawidłowy adres e-mail'),
  phone: standardString('Telefon').required().matches(PHONE_NUMBER_REGEX)
});
